import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'trial-account-alert',
    templateUrl: './trial-account-alert.component.html',
    styleUrls: ['./trial-account-alert.component.scss'],
    standalone: false
})
export class TrialAccountAlertComponent implements OnInit {
  @Input() remainingCreditCount?: number;
  @Input() remainingDays?: number;
  @Input() showUpgradeButton = true;

  public alertText: string;

  constructor() {}

  ngOnInit(): void {
      if (this.remainingDays! <= 4) {
          if (this.remainingCreditCount! <= 0) {
              this.alertText = `You have ${this.remainingDays} day(s) left in your free trial and you are also out of credits. Upgrade to a paid account to continue using Staitment.`;
          } else if (this.remainingCreditCount! <= 2) {
              this.alertText = `You have ${this.remainingDays} day(s) left in your free trial and you are also running low on free credits. Upgrade to a paid account to continue using Staitment.`;
          } else {
              this.alertText = `You have ${this.remainingDays} day(s) left in your free trial. Upgrade to a paid account to continue using Staitment.`;
          }
      } else if (this.remainingCreditCount! <= 0) {
          this.alertText = 'You are out of credits for the free trial. Upgrade to a paid account to continue using Staitment.';
      } else  {
          // if (this.remainingCreditCount <= 2)
          this.alertText = 'Your free trial is running low on credits. Upgrade to a paid account to get more.';
      }
  }
}
